import React, { useEffect, useState } from "react";
import "./Strategy.css";
import DecisionItems from "./DecisionItems";
import decisionValues from "../decision.json";
import { useMyContext } from "../../context/MyContext";

function Decision(props) {
  let [selectedObj, setSelectedObj] = useState("");
  let [showFields, setShowFields] = useState(false);
  let [decitionContent, setDecitionContent] = useState(
    props.decitionContent
      ? props.decitionContent
      : decisionValues.decitionItems[0].key
  );
  const { decisionObject, setDecisionObject } = useMyContext();
  const [filterText, setFilterText] = useState("");
  const [updateObj, setUpdateObj] = useState(false);

  const handleState = (obj) => {
    setSelectedObj(obj.id);
    localStorage.setItem("tabSelected", obj.id);
    setUpdateObj(!updateObj)
    // setShowFields(true);
    setDecisionObject({
      selectedObj: obj,
      showFields: true,
      type: props.type,
      nodeKey: props.nodeKey,
      id: props.id,
    });
    props.setExpandedL(false);
  };

  useEffect(() => {
    setSelectedObj(selectedObj);
    // props.setExpandedR(false);
    // props.setExpandedL(false);
    // console.log(props);
  }, [updateObj])

  const handleSelect = (key) => {
    // Handle tab selection if needed
    props.setDecitionContent(key);
    setDecitionContent(key);
    // setShowFields(false);
  };

  const filterItems = (subItem) => {
    if (!filterText) return true; // If no search string, show all
    return subItem.value.toLowerCase().includes(filterText.toLowerCase());
  };

  return (
    <>
      <div className="dashboard-topBar-search bg-white rounded-3 position-relative z-1 d-none d-md-block">
        <div className="icon d-flex align-items-center justify-content-center position-absolute top-50 translate-middle-y ms-3">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.75 15.7502L12.4928 12.4929M12.4928 12.4929C13.0499 11.9357 13.4919 11.2743 13.7934 10.5463C14.095 9.81834 14.2502 9.03811 14.2502 8.25015C14.2502 7.4622 14.095 6.68197 13.7934 5.95399C13.4919 5.22602 13.0499 4.56457 12.4928 4.0074C11.9356 3.45024 11.2741 3.00827 10.5462 2.70673C9.81819 2.4052 9.03795 2.25 8.25 2.25C7.46205 2.25 6.68181 2.4052 5.95384 2.70673C5.22587 3.00827 4.56442 3.45024 4.00725 4.0074C2.882 5.13265 2.24985 6.65881 2.24985 8.25015C2.24985 9.84149 2.882 11.3677 4.00725 12.4929C5.1325 13.6182 6.65866 14.2503 8.25 14.2503C9.84134 14.2503 11.3675 13.6182 12.4928 12.4929Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </svg>
        </div>
        <input
          type="search"
          placeholder="Search"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          className="form-control border-0 bg-transparent"
        />
      </div>

      {Object.keys(decisionValues.decitionData).map((key) =>
        decisionValues.decitionData[key].some(filterItems) ? (
          decisionValues.decitionData[key].map((subItem, subIndex) =>
            filterItems(subItem) ? (
              <div
                className={`action-item d-flex align-items-center justify-content-between`}
                key={`${key}-${subIndex}`}
                onClick={() => {
                  handleState(subItem);
                  handleSelect(key)
                }}
              >
                <p
                  dangerouslySetInnerHTML={{ __html: subItem.value }}
                />
              </div>
            ) : null
          )
        ) : (
          <div key={key} className="no-items-message">
            {/* No results found for {key}. */}
          </div>
        ))
      }
      {/* {(showFields && selectedObj != '') && <DecisionItems
                    decitionContent={decitionContent}
                    dataObj={selectedObj}
                    // updateObj={handleObj}
                    isOpen={showFields}
                    clickStr={props.clickStr}
                    type={props.type}
                    hideFields={setShowFields}
                    buildJSON={props.buildJSON}
                    setBuildJSON={props.setBuildJSON}
                    iterateCnt={props.iterateCnt}
                    setIterateCnt={props.setIterateCnt}
                    parentNode={props.parentNode}
                    setParentNode={props.setParentNode}
                    closeModal={props.handleClose}
                    nodeKey={props.nodeKey}
                    conditionCount={props.conditionCount}
                    setConditionCount={props.setConditionCount}
                    id={props.id}
                    openPositions={props.openPositions}
                    tagNames={props.tagNames}
                />} */}
    </>
  );
}

export default Decision;
